function GroupContainerController(
  $scope,
  $stateParams,
  navigationService,
  featureFlag
) {
  $scope.groupId = $stateParams.groupId;

  $scope.tasksv2enabled = false;
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    $scope.tasksv2enabled = enabled;
  });

  $scope.$watch(
    () => navigationService.currentNodeIdGroup,
    () => {
      $scope.currentNodeIdGroup = navigationService.currentNodeIdGroup;
    }
  );

  $scope.expanded = false;
  $scope.toggleExpansion = () => {
    $scope.expanded = !$scope.expanded;
  };
}

const arr = [
  '$scope',
  '$stateParams',
  'navigationService',
  'featureFlag',
  GroupContainerController
];

module.exports = (ngModule) => {
  ngModule.controller('GroupContainerController', arr);
};
